import { render, staticRenderFns } from "./TemplatesModal.vue?vue&type=template&id=7786942a&"
import script from "./TemplatesModal.vue?vue&type=script&lang=js&"
export * from "./TemplatesModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TemplatesModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/TemplatesModal.vue
// module id = 1668
// module chunks = 1